import apiSlice from "./ApiSlice";

export const jobBoardApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL JOB WITH PAGINATION
    getAllJobsWithPagination: builder.query({
      providesTags: ["job"],
      query: (body) => {
        return {
          url: "/job-board",
          method: "POST",
          body,
        };
      },
    }),
    // Add
    addJob: builder.mutation({
      invalidatesTags: ["job"],
      query: (body) => {
        return {
          url: "/job-board/add",
          method: "POST",
          body,
        };
      },
    }),
    // DELETE
    deleteJob: builder.mutation({
      invalidatesTags: ["job"],
      query: ({ id }) => {
        return {
          url: `/job-board/${id}`,
          method: "DELETE",
        };
      },
    }),
    // GET JOB BY ID
    getJobById: builder.query({
      providesTags: ["job"],
      query: ({ id }) => {
        return {
          url: `/job-board/${id}`,
          method: "GET",
        };
      },
    }),
    // EDIT
    editJob: builder.mutation({
      invalidatesTags: ["job"],
      query: ({ body, id }) => {
        return {
          url: `/job-board/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    // // GET ALL Questions WITH PAGINATION
    // getAllbatchesAssigmentsWithPagination: builder.query({
    //   providesTags: ["question", "batches"],
    //   query: ({ body, id }) => {
    //     return {
    //       url: `assignment/batch/${id}/get-batch-assignments`,
    //       method: "POST",
    //       body,
    //     };
    //   },
    // }),

    // //Add Remark
    // addQuestionRemark: builder.mutation({
    //   invalidatesTags: ["question"],
    //   query: ({ body, questionId, studentId, batchId }) => {
    //     return {
    //       url: `assignment/add-remark/${questionId}/batch/${batchId}/student/${studentId}`,
    //       method: "PUT",
    //       body,
    //     };
    //   },
    // }),
    // // GET CHAPTER BY ID
    // getStudentThoseNotCompleteAssignment: builder.query({
    //   providesTags: ["question"],
    //   query: ({ id }) => {
    //     return {
    //       url: `/assignment/${id}/not-submitted-assignment`,
    //       method: "GET",
    //     };
    //   },
    // }),
  }),
});

export const {
  useGetAllJobsWithPaginationQuery,
  useAddJobMutation,
  useDeleteJobMutation,
  useEditJobMutation,
  useGetJobByIdQuery,
  // useGetAllQuestionsWithPaginationQuery,
  // useAddQuestionsMutation,
  // useDeleteQuestionsMutation,
  // useEditQuestionsMutation,
  // useGetQuestionsByIdQuery,
} = jobBoardApi;
